import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { pt } from "date-fns/locale";
import { format } from "date-fns";

export function InputDateGroup({ id, value, onChange, placeholder, maxDate }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (date) => {
    onChange({
      target: {
        name: id,
        value: date ? format(date, "yyyy-MM-dd") : "",
      },
    });
  };

  return (
    <div className="date-wrapper input-date-group-custom d-flex align-items-center">
      <DatePicker
        selected={value ? new Date(value + "T00:00:00") : null}
        onChange={handleChange}
        locale={pt}
        maxDate={maxDate ? new Date(maxDate + "T00:00:00") : undefined}
        placeholderText={placeholder}
        dateFormat="dd/MM/yyyy"
        className="form-control date-input"
        wrapperClassName="w-100"
        open={isOpen}
        onClickOutside={() => setIsOpen(false)}
      />

      <div
        className="d-flex align-items-center text-center justify-content-center date-icon-bizin"
        role="button"
        tabIndex={0}
        onClick={() => setIsOpen(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen(true);
          }
        }}
      >
        <i className="fas fa-calendar-day" />
      </div>
    </div>
  );
}
